import { AxiosInstance } from "axios";

export interface AuthenticateMemberResponseI {
  access_token: string;
}

export const CircleAPIEndpoints = (api: AxiosInstance) => ({
  authenticateMember: (email: string) =>
    api.post<AuthenticateMemberResponseI>("/v1/circle/authenticate_member", {
      email,
    }),
});
